// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--j5oAO","close":"_4f720283bf--close--A7f7M","left":"_4f720283bf--left--STth3","title":"_4f720283bf--title--VMfJ1","text":"_4f720283bf--text--d9AY5"};